module.exports = __webpack_public_path__ + "1984877b86423675b7648f8c9f282959.png";